import { render } from "./OurExperts.vue?vue&type=template&id=4c6a6e3c&scoped=true"
import script from "./OurExperts.vue?vue&type=script&lang=js"
export * from "./OurExperts.vue?vue&type=script&lang=js"

import "./OurExperts.vue?vue&type=style&index=0&id=4c6a6e3c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c6a6e3c"]])

export default __exports__